/* ==========================================================================
   ALMAM - formularul de cerere de oferta
   ==========================================================================
   Singura treaba a fisierului: sa ceara cel putin un produs bifat.

   HTML-ul stie sa impuna un camp obligatoriu, dar nu si „cel putin una dintre
   aceste bife". Verificarea sta pe prima bifa din grup, prin `setCustomValidity`,
   deci foloseste chiar validarea browserului: acelasi balon de eroare si aceeasi
   oprire a trimiterii ca la campurile obligatoriu completate, fara mesaje
   desenate de noi.

   Textul erorii vine din editor, prin `data-quote-option-message`, nu e scris
   aici: altfel ar fi fost singurul text din pagina care nu se poate schimba
   fara cod.

   Fara JavaScript formularul ramane functional, doar fara aceasta verificare -
   celelalte campuri obligatorii sunt validate de browser oricum.
   ========================================================================== */

(function () {
  function bindGroup(form) {
    var boxes = form.querySelectorAll('[data-quote-option]');
    if (boxes.length === 0) return;

    var first = boxes[0];
    var message = first.getAttribute('data-quote-option-message') || '';

    function sync() {
      var checked = false;
      for (var i = 0; i < boxes.length; i++) {
        if (boxes[i].checked) {
          checked = true;
          break;
        }
      }
      first.setCustomValidity(checked ? '' : message);
    }

    for (var i = 0; i < boxes.length; i++) {
      boxes[i].addEventListener('change', sync);
    }

    sync();
  }

  function init() {
    var forms = document.querySelectorAll('.almam-quote-form__form');
    for (var i = 0; i < forms.length; i++) {
      bindGroup(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Editorul de teme reincarca sectiunea fara sa reincarce pagina, deci
     ascultatorii pusi la incarcare nu mai exista pe noul HTML. */
  document.addEventListener('shopify:section:load', init);
})();
